import { render } from "./EditarReceitasPlanos.vue?vue&type=template&id=4fa311af&scoped=true"
import script from "./EditarReceitasPlanos.vue?vue&type=script&lang=js"
export * from "./EditarReceitasPlanos.vue?vue&type=script&lang=js"

import "./EditarReceitasPlanos.vue?vue&type=style&index=0&id=4fa311af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa311af"]])

export default __exports__